import classNames from "classnames";
import type { HTMLComponent } from "@commercekit/react";

const WvLoadingCircle: HTMLComponent<{ bgColor?: string }> = ({
  bgColor = "bg-black/40",
  className,
}) => {
  return (
    <>
      <div
        className={classNames(
          "absolute top-0 left-0 right-0 bottom-0 z-10",
          bgColor
        )}
      />
      <div
        className={classNames(
          "absolute top-1/2 left-1/2 -mt-3.25 -ml-3.25 h-6.5 w-6.5 z-10 animate-spin rounded-full border-4 border-white border-t-blue-light",
          className
        )}
      />
    </>
  );
};

export default WvLoadingCircle;
